// extracted by css-extract-rspack-plugin
export default {"CompareItems":"CompareItems-module__CompareItems___yn9xL","compareItems":"CompareItems-module__CompareItems___yn9xL"};